import { render } from "./App.vue?vue&type=template&id=1244f54b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1244f54b&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1244f54b&lang=css"

import exportComponent from "C:\\Users\\69472\\Documents\\GitHub\\mcadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__